import { PocComponentHeader } from 'commons/components/components-wrapper/poc-component-header.component';
import { PocDivider } from 'commons/components/components-wrapper/poc-divider.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { CustomField } from 'core/service/custom-fields/custom-field.type';
import { useTranslation } from 'core/i18n/i18n';
import { SettingsCardLayout } from 'modules/settings/settings.style';
import React, { Fragment } from 'react';
import { CustomFieldComponent } from './commons/custom-field.component';

interface SettingsSystemCustomFieldsComponentProps {
    customFields: CustomField[];
    onClickCustomFieldOptions: (customField: CustomField) => void;
}

export const SettingsSystemCustomFieldsComponent: React.FC<SettingsSystemCustomFieldsComponentProps> = (props) => {
    const { customFields, onClickCustomFieldOptions } = props;

    const { t } = useTranslation();

    return (
        <SettingsCardLayout interactive rounded>
            <PocComponentHeader slot="header" style={{ paddingTop: '12px' }}>
                <PocTypography element="h6" variant="title6">
                    {t('settings.system.custom-fields.fields.title', { total: customFields.length })}
                </PocTypography>
            </PocComponentHeader>
            <>
                {customFields.length ? (
                    customFields.map((c, index) => (
                        <Fragment key={`custom-field-${c.id}`}>
                            {!!index && <PocDivider key={`custom-divider-${c.id}`} />}
                            <CustomFieldComponent
                                key={c.id}
                                customField={c}
                                onClickOptions={onClickCustomFieldOptions}
                            />
                        </Fragment>
                    ))
                ) : (
                    <PocTypography element="p" variant="body1">
                        {t('settings.system.custom-fields.fields.empty')}
                    </PocTypography>
                )}
            </>
        </SettingsCardLayout>
    );
};
